function decodeBase64Url(str) {
  const base64 = str
    .replace(/-/g, "+")
    .replace(/_/g, "/")
    .padEnd(Math.ceil(str.length / 4) * 4, "=");

  return Buffer.from(base64, "base64").toString("utf-8");
}

function getIssuedAtFromAccessToken(token) {
  const rawPayload = token.split(".")[1];
  const payload = JSON.parse(decodeBase64Url(rawPayload));

  return new Date(payload.iat * 1000);
}

export {
  decodeBase64Url,
  getIssuedAtFromAccessToken
};




// WEBPACK FOOTER //
// ./src/components/login/loginUtils.js